import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

import api from "../services/api";

import "./HospitalityAuditsPage.css";


const SeahausAuditsPage = () => {
  const navigate = useNavigate();

  const { locationId } =
    useParams();


  // ==========================================
  // LOCATION
  // ==========================================

  const [
    hotelLocation,
    setHotelLocation,
  ] = useState(null);

  const location = useLocation();

const initialReportDate =
  String(
    location.state?.reportDate || ""
  ).slice(0, 10);

  // ==========================================
  // SEAHAUS DATA
  // ==========================================

  const [
    revenue,
    setRevenue,
  ] = useState([]);

  const [
    houseCount,
    setHouseCount,
  ] = useState([]);

  

  const [
    reservations,
    setReservations,
  ] = useState([]);

  const [
    dailyFill,
    setDailyFill,
  ] = useState([]);

  const [
    depositReservations,
    setDepositReservations,
  ] = useState([]);

  const [
    depositDailyFill,
    setDepositDailyFill,
  ] = useState([]);

  const [
    nightAudits,
    setNightAudits,
  ] = useState([]);

  const [
    occupancyCalendar,
    setOccupancyCalendar,
  ] = useState(null);

  const [
  showRevenueBreakdown,
  setShowRevenueBreakdown,
] = useState(false);


  // ==========================================
  // PAGE STATE
  // ==========================================

 const [
  selectedReportDate,
  setSelectedReportDate,
] = useState(initialReportDate);

  const [
    loading,
    setLoading,
  ] = useState(true);

  const [
    error,
    setError,
  ] = useState("");


  // ==========================================
  // FETCH DATA
  // ==========================================

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");


        // --------------------------------
        // LOCATION
        // --------------------------------

        const locationRes =
          await api.get(
            `/hospitality/location/${locationId}`
          );

        const locationData =
          locationRes.data;

        if (
          String(
            locationData?.brand || ""
          ).toLowerCase() !==
          "seahaus"
        ) {
          setError(
            "This location is not a Seahaus location."
          );

          return;
        }

        setHotelLocation(
          locationData
        );


        // --------------------------------
        // SEAHAUS DATA
        // --------------------------------

        const [
          revenueRes,
          houseCountRes,
          reservationsRes,
          dailyFillRes,
          depositReservationsRes,
          depositDailyFillRes,
          nightAuditsRes,
          occupancyCalendarRes,
        ] = await Promise.all([

          api.get(
            `/hospitality/seahaus/daily-revenue/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/house-count/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/reservations/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/daily-fill/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/deposit-reservations/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/deposit-daily-fill/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/night-audits/${locationId}`
          ),

          api.get(
            `/hospitality/seahaus/occupancy-calendar/${locationId}`
          ),

        ]);


        setRevenue(
          revenueRes.data || []
        );

        setHouseCount(
          houseCountRes.data || []
        );

        setReservations(
          reservationsRes.data || []
        );

        setDailyFill(
          dailyFillRes.data || []
        );

        setDepositReservations(
          depositReservationsRes.data || []
        );

        setDepositDailyFill(
          depositDailyFillRes.data || []
        );

        setNightAudits(
          nightAuditsRes.data || []
        );

        setOccupancyCalendar(
          occupancyCalendarRes.data || null
        );



        if (!initialReportDate) {
  if (
    revenueRes.data?.length > 0
  ) {
    setSelectedReportDate(
      String(
        revenueRes.data[0]
          .report_date
      ).slice(0, 10)
    );
  }
}
        // --------------------------------
        // DEFAULT REPORT DATE
        // --------------------------------

        

      } catch (err) {
        console.error(
          "Failed to load Seahaus audit:",
          err
        );

        setError(
          err?.response?.data?.message ||
          "Failed to load Seahaus audit data."
        );

      } finally {
        setLoading(false);
      }
    };


    if (locationId) {
      fetchData();
    }

 }, [locationId, initialReportDate]);


  // ==========================================
  // LOADING
  // ==========================================

  if (loading) {
    return (
      <div className="hospitality-audits-page">

        <p>
          Loading Seahaus data...
        </p>

      </div>
    );
  }


  // ==========================================
  // HELPERS
  // ==========================================

  const formatDateKey = (date) => {
    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    return (
      `${year}-${month}-${day}`
    );
  };

  

  const formatMoney = (value) => {
    return Number(
      value || 0
    ).toLocaleString(
      "en-US",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    );
  };


  const formatDisplayDate = (
    value
  ) => {
    if (!value) {
      return "-";
    }

    const dateString =
      String(value).slice(0, 10);

    const [
      year,
      month,
      day,
    ] = dateString
      .split("-")
      .map(Number);

    return new Date(
      year,
      month - 1,
      day
    ).toLocaleDateString();
  };


  // ==========================================
  // SELECTED DATE DATA
  // ==========================================

  const selectedRevenue =
    revenue.find(
      (row) =>
        String(
          row.report_date
        ).slice(0, 10) ===
        selectedReportDate
    ) || null;


  const selectedHouseCount =
    houseCount.find(
      (row) =>
        String(
          row.report_date
        ).slice(0, 10) ===
        selectedReportDate
    ) || null;


  // ==========================================
  // REVENUE ROWS
  // ==========================================

  const revenueRows =
    selectedRevenue
      ? [
          {
            name:
              "Room Revenue",

            today:
              selectedRevenue
                .room_revenue_today,

            mtd:
              selectedRevenue
                .room_revenue_mtd,

            lastMtd:
              selectedRevenue
                .room_revenue_last_year_mtd,

            ytd:
              selectedRevenue
                .room_revenue_ytd,

            lastYtd:
              selectedRevenue
                .room_revenue_last_year_ytd,
          },

          {
            name:
              "Cucina Del Mar",

            today:
              selectedRevenue
                .cucina_today,

            mtd:
              selectedRevenue
                .cucina_mtd,

            lastMtd:
              selectedRevenue
                .cucina_last_year_mtd,

            ytd:
              selectedRevenue
                .cucina_ytd,

            lastYtd:
              selectedRevenue
                .cucina_last_year_ytd,
          },

          {
            name:
              "CDM Bakery + Cafe",

            today:
              selectedRevenue
                .bakery_today,

            mtd:
              selectedRevenue
                .bakery_mtd,

            lastMtd:
              selectedRevenue
                .bakery_last_year_mtd,

            ytd:
              selectedRevenue
                .bakery_ytd,

            lastYtd:
              selectedRevenue
                .bakery_last_year_ytd,
          },

          {
            name:
              "Parking",

            today:
              selectedRevenue
                .parking_today,

            mtd:
              selectedRevenue
                .parking_mtd,

            lastMtd:
              selectedRevenue
                .parking_last_year_mtd,

            ytd:
              selectedRevenue
                .parking_ytd,

            lastYtd:
              selectedRevenue
                .parking_last_year_ytd,
          },
        ]
      : [];


  // ==========================================
  // TOTAL REVENUE VALUES
  // ==========================================

 const totalRevenueToday =
  revenueRows.reduce(
    (total, row) =>
      total +
      (Number(row.today) || 0),
    0
  );

const totalRevenueMTD =
  revenueRows.reduce(
    (total, row) =>
      total +
      (Number(row.mtd) || 0),
    0
  );

const totalRevenueLastMTD =
  revenueRows.reduce(
    (total, row) =>
      total +
      (Number(row.lastMtd) || 0),
    0
  );

const totalRevenueYTD =
  revenueRows.reduce(
    (total, row) =>
      total +
      (Number(row.ytd) || 0),
    0
  );

const totalRevenueLastYTD =
  revenueRows.reduce(
    (total, row) =>
      total +
      (Number(row.lastYtd) || 0),
    0
  );

  // ==========================================
  // OCCUPANCY
  // ==========================================

  const availableRooms =
    selectedHouseCount
      ? Number(
          selectedHouseCount
            .available_rooms
        ) || 0
      : 0;


  const totalCommitted =
    selectedHouseCount
      ? Number(
          selectedHouseCount
            .total_committed
        ) || 0
      : 0;


  const selectedOccupancyPercent =
    availableRooms > 0
      ? (
          (
            totalCommitted /
            availableRooms
          ) * 100
        ).toFixed(2)
      : null;


  // ==========================================
  // REVENUE COMPARISON
  // ==========================================



  // ==========================================
  // CALENDAR MONTH BUILDER
  // ==========================================

  const buildCalendarMonth = (
    year,
    month
  ) => {
    const firstDay =
      new Date(
        year,
        month,
        1
      );

    const lastDay =
      new Date(
        year,
        month + 1,
        0
      );

    const cells = [];


    for (
      let i = 0;
      i < firstDay.getDay();
      i++
    ) {
      cells.push(null);
    }


    for (
      let day = 1;
      day <= lastDay.getDate();
      day++
    ) {
      cells.push(
        new Date(
          year,
          month,
          day
        )
      );
    }

    return cells;
  };


  const totalDeposits =
  depositReservations.reduce(
    (total, row) =>
      total +
      (Number(row.gross_deposit) || 0),
    0
  );

  
  // ==========================================
  // CALENDAR MONTHS
  // ==========================================

  const getCalendarMonths = () => {
  if (!selectedReportDate) {
    return [];
  }

  const [
    year,
    month,
    day,
  ] = selectedReportDate
    .split("-")
    .map(Number);

  if (
    !year ||
    !month ||
    !day
  ) {
    return [];
  }

  const months = [];

  for (
    let i = 0;
    i < 3;
    i++
  ) {
    months.push(
      new Date(
        year,
        month - 1 + i,
        1
      )
    );
  }

  return months;
};


  // ==========================================
  // CALENDAR OCCUPANCY
  // ==========================================

  const getOccupancyForDate = (date) => {
  const dateKey =
    formatDateKey(date);

  if (!selectedReportDate) {
    return null;
  }

  // --------------------------------
  // REPORT DATE OR EARLIER
  // USE ACTUAL HOUSE COUNT
  // --------------------------------

  if (dateKey <= selectedReportDate) {
    const actualHouseCount =
      houseCount.find(
        (row) =>
          String(
            row.report_date
          ).slice(0, 10) ===
          dateKey
      );

    if (!actualHouseCount) {
      return null;
    }

    const totalRooms =
      Number(
        actualHouseCount
          .available_rooms
      ) || 0;

    const roomsBooked =
      Number(
        actualHouseCount
          .total_committed
      ) || 0;

    return {
      date: dateKey,

      totalRooms,

      roomsBooked,

      occupancyPercent:
        totalRooms > 0
          ? Number(
              (
                (
                  roomsBooked /
                  totalRooms
                ) *
                100
              ).toFixed(2)
            )
          : 0,

      source: "house-count",
    };
  }


  // --------------------------------
  // AFTER REPORT DATE
  // CONFIRMED DAILY FILL
  // --------------------------------

  

  const confirmedRooms =
    dailyFill.filter(
      (row) =>
        String(
          row.stay_date
        ).slice(0, 10) ===
        dateKey
    ).length;


  // --------------------------------
  // AFTER REPORT DATE
  // DEPOSIT ESTIMATED DAILY FILL
  // --------------------------------

  const depositRooms =
    depositDailyFill.filter(
      (row) =>
        String(
          row.stay_date
        ).slice(0, 10) ===
        dateKey
    ).length;


  // --------------------------------
  // TOTAL FUTURE ROOMS
  // --------------------------------

  const roomsBooked =
    confirmedRooms +
    depositRooms;


  /*
    Seahaus total inventory comes from
    latest House Count Available Rooms.

    For 8/10/2026 this is 104.
  */

  const latestHouseCount =
    houseCount.find(
      (row) =>
        String(
          row.report_date
        ).slice(0, 10) ===
        selectedReportDate
    );

  const totalRooms =
    Number(
      latestHouseCount
        ?.available_rooms
    ) || 0;


  if (roomsBooked === 0) {
    return null;
  }


  return {
    date: dateKey,

    totalRooms,

    roomsBooked,

    occupancyPercent:
      totalRooms > 0
        ? Number(
            (
              (
                roomsBooked /
                totalRooms
              ) *
              100
            ).toFixed(2)
          )
        : 0,

    source: "daily-fill",
  };
};


  // ==========================================
  // PAGE
  // ==========================================

  return (
    <div className="hospitality-audits-page">


      {/* ==========================================
          DASHBOARD BUTTON
      ========================================== */}

      <button
        type="button"
        className="hospitality-audits-back"
        onClick={() =>
          navigate(
            "/hospitality"
          )
        }
      >
        Dashboard
      </button>


      {/* ==========================================
          HEADER
      ========================================== */}

      <div className="hospitality-audits-header">

        <div>
          <h1>
            Seahaus Night Audit
          </h1>
        </div>

      </div>


      {/* ==========================================
          ERROR
      ========================================== */}

      {error && (
        <div className="hospitality-audits-empty">
          {error}
        </div>
      )}


      {!error &&
       revenue.length === 0 && (
        <div className="hospitality-audits-empty">

          No night audit data is
          available for this location yet.

        </div>
      )}


      {/* ==========================================
          REPORT TOTALS / DATE
      ========================================== */}

      <div className="hospitality-report-totals-row">


        <div className="hospitality-report-totals">


          <div>

            <span>
              Location
            </span>

            <strong>
              {hotelLocation?.location ||
                "-"}
            </strong>

          </div>


          <div>

            <span>
              Revenue Today
            </span>

            <strong>
              {selectedRevenue
                ? `$${formatMoney(
                    totalRevenueToday
                  )}`
                : "-"}
            </strong>

          </div>


          <div>

            <span>
              Revenue MTD
            </span>

            <strong>
              {selectedRevenue
                ? `$${formatMoney(
                    totalRevenueMTD
                  )}`
                : "-"}
            </strong>

          </div>


          <div>

            <span>
              Revenue YTD
            </span>

            <strong>
              {selectedRevenue
                ? `$${formatMoney(
                    totalRevenueYTD
                  )}`
                : "-"}
            </strong>

          </div>


        </div>


        <div className="hospitality-report-date-picker">

          <label>
            Report Date
          </label>

          <input
            type="date"
            value={
              selectedReportDate
            }
            onChange={(e) =>
              setSelectedReportDate(
                e.target.value
              )
            }
          />

        </div>

      </div>


      {/* ==========================================
          NO DATA FOR SELECTED DATE
      ========================================== */}

      {selectedReportDate &&
       !selectedRevenue &&
       !selectedHouseCount && (

        <div className="hospitality-report-no-data">

          No report data available for{" "}
          {selectedReportDate}.

        </div>

      )}


      {/* ==========================================
          SUMMARY CARDS
      ========================================== */}

      <div className="hospitality-hotel-summary-cards">


        <div className="hospitality-hotel-summary-card">

          <span>
            Available Rooms
          </span>

          <strong>
            {selectedHouseCount
              ? availableRooms
              : "-"}
          </strong>

        </div>


        <div className="hospitality-hotel-summary-card">

          <span>
            Total Committed
          </span>

          <strong>
            {selectedHouseCount
              ? totalCommitted
              : "-"}
          </strong>

        </div>


        <div className="hospitality-hotel-summary-card">

          <span>
            Occupancy
          </span>

          <strong>
            {selectedOccupancyPercent !==
            null
              ? `${selectedOccupancyPercent}%`
              : "-"}
          </strong>

        </div>


        <div className="hospitality-hotel-summary-card">

          <span>
            Room Revenue
          </span>

          <strong>
            {selectedRevenue
              ? `$${formatMoney(
                  selectedRevenue
                    .room_revenue_today
                )}`
              : "-"}
          </strong>

        </div>


        <div className="hospitality-hotel-summary-card">

          <span>
            Total Revenue
          </span>

          <strong>
            {selectedRevenue
              ? `$${formatMoney(
                  totalRevenueToday
                )}`
              : "-"}
          </strong>

        </div>


      </div>


      {/* ==========================================
          REVENUE SUMMARY TABLE
      ========================================== */}

     

<div className="hospitality-audits-table-wrap">

  <table className="hospitality-audits-table">

    <thead>
      <tr>
        <th></th>
        <th>Department</th>
        <th>Today</th>
        <th>MTD</th>
        <th>Last Yr MTD</th>
        <th>YTD</th>
        <th>Last YTD</th>
      </tr>
    </thead>

    <tbody>

      {!selectedRevenue ? (

        <tr>
          <td colSpan="7">
            No revenue records.
          </td>
        </tr>

      ) : (

        <>

          {/* =====================================
              COMBINED TOTAL ROW
          ===================================== */}

          <tr
            className="hospitality-revenue-total-row"
            onClick={() =>
              setShowRevenueBreakdown(
                (prev) => !prev
              )
            }
          >

            <td
              className="hospitality-revenue-expand"
            >
              {showRevenueBreakdown
                ? "▼"
                : "▶"}
            </td>

            <td>
              <strong>
                Total Revenue
              </strong>
            </td>

            <td>
              <strong>
                $
                {formatMoney(
                  totalRevenueToday
                )}
              </strong>
            </td>

            <td>
              <strong>
                $
                {formatMoney(
                  totalRevenueMTD
                )}
              </strong>
            </td>

            <td>
              <strong>
                $
                {formatMoney(
                  totalRevenueLastMTD
                )}
              </strong>
            </td>

            <td>
              <strong>
                $
                {formatMoney(
                  totalRevenueYTD
                )}
              </strong>
            </td>

            <td>
              <strong>
                $
                {formatMoney(
                  totalRevenueLastYTD
                )}
              </strong>
            </td>

          </tr>


          {/* =====================================
              EXPANDED DEPARTMENT ROWS
          ===================================== */}

          {showRevenueBreakdown &&
            revenueRows.map(
              (row) => (

                <tr
                  key={row.name}
                  className="hospitality-revenue-detail-row"
                >

                  <td></td>

                  <td>
                    {row.name}
                  </td>

                  <td>
                    $
                    {formatMoney(
                      row.today
                    )}
                  </td>

                  <td>
                    $
                    {formatMoney(
                      row.mtd
                    )}
                  </td>

                  <td>
                    $
                    {formatMoney(
                      row.lastMtd
                    )}
                  </td>

                  <td>
                    $
                    {formatMoney(
                      row.ytd
                    )}
                  </td>

                  <td>
                    $
                    {formatMoney(
                      row.lastYtd
                    )}
                  </td>

                </tr>

              )
            )}

        </>

      )}

    </tbody>

  </table>

</div>

      {/* ==========================================
          OCCUPANCY CALENDAR
      ========================================== */}

     


      {occupancyCalendar ? (

        <div className="hospitality-calendar-layout">


          <div className="hospitality-calendar-left">

            <div className="hospitality-calendar-months">


              {getCalendarMonths().map(
                (monthDate) => {

                  const year =
                    monthDate
                      .getFullYear();

                  const month =
                    monthDate
                      .getMonth();

                  const cells =
                    buildCalendarMonth(
                      year,
                      month
                    );


                  return (
                    <div
                      className="hospitality-calendar-month"
                      key={`${year}-${month}`}
                    >

                      <h3>

                        {monthDate
                          .toLocaleDateString(
                            undefined,
                            {
                              month:
                                "long",

                              year:
                                "numeric",
                            }
                          )}

                      </h3>


                      <div className="hospitality-calendar-weekdays">

                        <div>Sun</div>
                        <div>Mon</div>
                        <div>Tue</div>
                        <div>Wed</div>
                        <div>Thu</div>
                        <div>Fri</div>
                        <div>Sat</div>

                      </div>


                      <div className="hospitality-calendar-grid">


                        {cells.map(
                          (
                            date,
                            index
                          ) => {

                            if (!date) {
                              return (
                                <div
                                  key={`empty-${index}`}
                                  className="hospitality-calendar-day hospitality-calendar-day-empty"
                                />
                              );
                            }


                            const occupancy =
                              getOccupancyForDate(
                                date
                              );


                            return (
                              <div
                                key={
                                  formatDateKey(
                                    date
                                  )
                                }

                                className={`hospitality-calendar-day ${
                                  occupancy
                                    ? Number(
                                        occupancy
                                          .occupancyPercent
                                      ) > 40

                                      ? "hospitality-occupancy-high"

                                      : Number(
                                          occupancy
                                            .occupancyPercent
                                        ) >= 20

                                      ? "hospitality-occupancy-medium"

                                      : "hospitality-occupancy-low"

                                    : ""
                                }`}
                              >


                                <div className="hospitality-calendar-date">

                                  {date.getDate()}

                                </div>


                                {occupancy ? (

                                  <>

                                    <div className="hospitality-calendar-percent">

                                      {
                                        occupancy
                                          .occupancyPercent
                                      }
                                      %

                                    </div>


                                    <div className="hospitality-calendar-rooms">

                                      {
                                        occupancy
                                          .roomsBooked
                                      }

                                      {" / "}

                                      {
                                        occupancy
                                          .totalRooms
                                      }

                                    </div>

                                  </>

                                ) : (

                                  <div className="hospitality-calendar-no-data">
                                    -
                                  </div>

                                )}


                              </div>
                            );
                          }
                        )}


                      </div>

                    </div>
                  );
                }
              )}


            </div>

          </div>


          {/* ======================================
              CALENDAR RIGHT
          ====================================== */}

          <div className="hospitality-calendar-right">

          <div className="hospitality-calendar-deposit-item">
    <span>Total Deposits</span>

    <strong>
      ${formatMoney(totalDeposits)}
    </strong>
  </div>


            <div className="hospitality-calendar-deposit-item">

              <span>
                Confirmed Reservations
              </span>

              <strong>
                {reservations.length}
              </strong>

            </div>


            <div className="hospitality-calendar-deposit-item">

              <span>
                Deposit Reservations
              </span>

              <strong>
                {depositReservations.length}
              </strong>

            </div>


            <div className="hospitality-calendar-deposit-item">

              <span>
                Confirmed Daily Fill
              </span>

              <strong>
                {dailyFill.length}
              </strong>

            </div>


            <div className="hospitality-calendar-deposit-item">

              <span>
                Estimated Daily Fill
              </span>

              <strong>
                {depositDailyFill.length}
              </strong>

            </div>


            <div className="hospitality-calendar-deposit-item">

              <span>
                Night Audits
              </span>

              <strong>
                {nightAudits.length}
              </strong>

            </div>


          </div>


        </div>

      ) : (

        <p>
          No occupancy calendar data.
        </p>

      )}


      {/* ==========================================
          CONFIRMED RESERVATIONS
      ========================================== */}

      <h2
      >
        Reservations
      </h2>


      <div className="hospitality-audits-table-wrap">

        <table className="hospitality-audits-table">

          <thead>

            <tr>

              <th>
                Room
              </th>

              <th>
                Guest
              </th>

              <th>
                Arrival
              </th>

              <th>
                Departure
              </th>

              <th>
                Full Rate
              </th>

            </tr>

          </thead>


          <tbody>

            {reservations.length === 0 ? (

              <tr>

                <td colSpan="5">
                  No reservation records.
                </td>

              </tr>

            ) : (

              reservations.map(
                (row) => (

                  <tr key={row.id}>

                    <td>
                      {row.room_number ||
                        "-"}
                    </td>

                    <td>
                      {row.guest_name ||
                        "-"}
                    </td>

                    <td>
                      {formatDisplayDate(
                        row.arrival_date
                      )}
                    </td>

                    <td>
                      {formatDisplayDate(
                        row.departure_date
                      )}
                    </td>

                    <td>
                      $
                      {formatMoney(
                        row.full_rate
                      )}
                    </td>

                  </tr>

                )
              )

            )}

          </tbody>

        </table>

      </div>


      {/* ==========================================
          DEPOSIT RESERVATIONS
      ========================================== */}

      <h2
        style={{
          marginTop: "35px",
        }}
      >
        Deposit Reservations
      </h2>


      <div className="hospitality-audits-table-wrap">

        <table className="hospitality-audits-table">

          <thead>

            <tr>

              <th>
                Status
              </th>

              <th>
                Guest
              </th>

              <th>
                Arrival
              </th>

              <th>
                Gross Deposit
              </th>

              <th>
                Net Deposit
              </th>

              <th>
                Estimated Nights
              </th>

            </tr>

          </thead>


          <tbody>

            {depositReservations.length ===
            0 ? (

              <tr>

                <td colSpan="6">
                  No deposit reservation records.
                </td>

              </tr>

            ) : (

              depositReservations.map(
                (row) => (

                  <tr key={row.id}>

                    <td>
                      {row.reservation_status ||
                        "-"}
                    </td>

                    <td>
                      {row.guest_name ||
                        "-"}
                    </td>

                    <td>
                      {formatDisplayDate(
                        row.arrival_date
                      )}
                    </td>

                    <td>
                      $
                      {formatMoney(
                        row.gross_deposit
                      )}
                    </td>

                    <td>
                      $
                      {formatMoney(
                        row.net_deposit
                      )}
                    </td>

                    <td>
                      {row.estimated_nights ??
                        "-"}
                    </td>

                  </tr>

                )
              )

            )}

          </tbody>

        </table>

      </div>


    </div>
  );
};


export default SeahausAuditsPage;